export const bankAccountVerificationOfferingsType = {
   VERIFY_BANK_ACCOUNT: {
      key: "verify_Bank_Account",
      label: "Verify Bank Account",
   },
   VERIFY_UPI_ID: {
      key: "verify_UPI_ID",
      label: "Verify UPI ID",
   },
};

export const bankAccountVerificationSteps = {
   INITIAL_STEP: 0,
   USER_DETAILS: 1,
   RESULT: 2,
};
